import { useDispatch } from 'react-redux';

import { useQuery } from '@tanstack/react-query';
import { BusinessRelationshipResponse } from 'types/BusinessRelationship';
import { AxiosError } from 'axios';
import { openModal } from 'reducers/modalReducer';
import contactNoteDialogService from 'services/contactNoteDialogService';

//This is to retrieve the prepopulate business relationship in create/edit flow for BR(Business Relationship)
export const useFetchBRBusinessRelationship = (brUid: string, usedInBr: boolean) => {
  const dispatch = useDispatch();
  return useQuery<BusinessRelationshipResponse, AxiosError>({
    queryKey: ['getBrDetails', brUid],
    queryFn: () => contactNoteDialogService.getBusinessRelationship(brUid),
    enabled: usedInBr,
    onError: (error: AxiosError) =>
      dispatch(
        openModal({
          modalType: 'ErrorDialog',
          modalProps: { error },
        }),
      ),
  });
};
